<template>
    <div class="we-dropdown">
        <button
            class="btn btn--with-icon btn--inverted-flat"
            @click="showFilters = !showFilters"
        >
            <vs-icon icon="filter_list" class="search-icon" />
            <span>Filtrar / Ordenar</span>
        </button>
        <div
            class="we-dropdown-menu dropdown-menu"
            :class="{ 'is-visible': showFilters }"
        >
            <!-- Para filtro de estados -->
            <div class="input-group org-filter">
                <span>Estado</span>
                <select v-model="organizationSelectedState" name="stateFilter">
                    <option value="all">Todos</option>
                    <option
                        v-for="state in allOrganizationStates"
                        v-bind:value="state"
                        :key="state.value"
                    >
                        {{ $t(`organization.registrationState.${state}`) }}
                    </option>
                    <label for="stateFilter">Empresa</label>
                </select>
            </div>

             <!-- Para el filtro de tipo empresa (compra,venta,mixta) -->
            <div class="input-group org-filter">
                <span>Tipo de empresa</span>
                <select v-model="organizationTypeFilterSelected">
                     <option value="all">Cualquiera</option>
                    <option
                        v-for="orgType in ['buyer','seller','mixed']"
                        v-bind:value="orgType"
                        :key="orgType"
                    >
                        {{ $t(`organization.filterBy.${orgType}`) }}
                    </option>
                </select>
            </div>
            <br>
            <hr class="divisor">
            <!-- Para ordenamiento -->
            <div class="input-group org-filter">
                <span>Ordenar por</span>
                <select v-model="sortSelectedOption">
                    <option
                        v-for="sortOption in allSortOptions"
                        v-bind:value="sortOption"
                        :key="sortOption"
                    >
                        {{ $t(`organization.orderBy.${sortOption}`) }}
                    </option>
                </select>
            </div>

           

            <br />

            <vs-switch v-model="sortDescOption" class="order-switch">
                <span slot="on"><b>Descendente</b></span>
                <span slot="off"><b> Ascendente</b></span>
            </vs-switch>
            <br /><br />
            <vs-button
                @click="applyOrderAndFilter"
                class="btn btn-flat to-right"
                color="primary"
                type="border"
                >Aplicar</vs-button
            >
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showFilters: false,
            organizationSelectedState: "all",
            organizationTypeFilterSelected: "all",
            allOrganizationStates: [
                "disabled",
                "enabled",
                "documentation_pending",
                "aproval_pending",
                "rejected",
            ],
            sortSelectedOption: "created_at",
            allSortOptions: ["created_at", "business_name", "registration_state"],
            sortDescOption: true,
        };
    },
    created() {
        document.addEventListener("click", this.onClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.onClickOutside);
    },

    methods: {
        onClickOutside(ev) {
            if (!this.$el.contains(ev.target)) {
                this.closeFilters();
            }
        },
        applyOrderAndFilter() {
            this.$emit("update-filters", {
                sort: {
                    sortBy: this.sortSelectedOption,
                    desc: this.sortDescOption,
                },
                filter: { state: this.organizationSelectedState, type: this.organizationTypeFilterSelected },
            });
            this.closeFilters();
        },
        closeFilters() {
            this.showFilters = false;
        },
    },

    watch: {},
};
</script>
<style scoped>
.btn:hover {
    box-shadow: 0 0;
}
.order-switch {
    min-width: 100px;
    margin: auto;
}

.to-right {
    float: right;
}
.org-filter{
    margin-top: 20px;
}
.divisor{
    margin:0px
}

@media only screen and (min-width: 992px) {
    .btn {
        padding: 0px;
    }
}
</style>
